export default "__VITE_ASSET__Byne28tz__"